// frame: SobPx @ ui/dogdisk-user.pen
// spec: docs/ui/user-page-flows.md §2.7 SobPx 页面-离线状态
//
// PWA Service Worker fetch fail 时强制路由到此。可缓存的文件仍可离线访问。

import { ErrorPageView } from './_view'

export function OfflinePage() {
  const retry = () => {
    if (typeof window !== 'undefined') window.location.reload()
  }
  return (
    <ErrorPageView
      frameId="SobPx"
      code={null}
      title="无网络连接"
      desc={
        <>
          请检查您的网络设置后重试。
          <br />
          部分已缓存的文件仍可离线访问。
        </>
      }
      icon={
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 1l22 22" />
          <path d="M16.72 11.06A10.94 10.94 0 0119 12.55" />
          <path d="M5 12.55a10.94 10.94 0 015.17-2.39" />
          <path d="M10.71 5.05A16 16 0 0122.58 9" />
          <path d="M1.42 9a15.91 15.91 0 014.7-2.88" />
          <path d="M8.53 16.11a6 6 0 016.95 0" />
          <path d="M12 20h.01" />
        </svg>
      }
      actions={
        <button
          type="button"
          data-testid="6Ds05"
          onClick={retry}
          className="h-12 w-full rounded-lg bg-[#19caad] text-[14px] font-semibold text-white active:bg-[#14a18b]"
        >
          点击重试网络连接
        </button>
      }
    />
  )
}
